// vocabulary_card — image + Arabic word + English gloss + audio. Presentational.

import { useEffect, type ReactElement } from 'react';

import type { content } from '@fajrarabi/zod-schemas';

import { ActivityImage, ArabicText, AudioButton } from './primitives';
import type { ActivityRendererProps } from './types';

export function VocabularyCard({
  data,
  ctx,
  cb,
}: ActivityRendererProps<content.VocabularyCardData>): ReactElement {
  const { t } = ctx;
  useEffect(() => {
    cb.onViewed();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mx-auto flex max-w-sm flex-col items-center text-center">
      <div className="w-56">
        <ActivityImage src={data.image} ctx={ctx} alt={t(data.wordKey)} fallbackEmoji="🍎" />
      </div>
      <h2 className="mt-6 text-3xl font-bold text-burgundy-700">
        <ArabicText text={t(data.wordKey)} ctx={ctx} />
      </h2>
      {data.glossKey ? <p className="mt-1 text-lg text-ink-500">{t(data.glossKey)}</p> : null}
      <div className="mt-5">
        <AudioButton src={data.audio} ctx={ctx} label={t('content.common.play_audio')} />
      </div>
    </div>
  );
}
